import { getProductNameParts } from "../helper/productName";

export function ProductNameDisplay({
  displayName,
  language,
  className = "",
  languageClassName = "",
  stacked = false,
}) {
  if (!language) {
    return <span className={className}>{displayName}</span>;
  }

  if (stacked) {
    return (
      <span className="product-name-display product-name-display--stacked">
        <span className={className}>{displayName}</span>
        <span className={`product-language-tag ${languageClassName}`.trim()}>{language}</span>
      </span>
    );
  }

  return (
    <span className={className}>
      {displayName}
      <span className={`product-language-tag ${languageClassName}`.trim()}> {language}</span>
    </span>
  );
}

export default function ProductName({
  name,
  type,
  className = "",
  languageClassName = "",
  stacked = false,
  useFullName = false,
}) {
  const { titleName, displayName, language } = getProductNameParts(name, type);

  return (
    <ProductNameDisplay
      displayName={useFullName ? displayName : titleName}
      language={language}
      className={className}
      languageClassName={languageClassName}
      stacked={stacked}
    />
  );
}
